


/* preload images of the slider */

document.addEventListener("DOMContentLoaded", function () {
  // Select the first image with the class 'slideshow-slide__image'
  const firstImage = document.querySelector(".slideshow-slide__image");

  if (firstImage) {
    // Create a new image element to preload
    const img = new Image();
    img.src = firstImage.getAttribute("src");

    // Optional: Listen for the load event to confirm the image is preloaded
    img.onload = function () {
      console.log(`Image ${img.src} preloaded`);
    };

    // Optional: Handle error if the image fails to load
    img.onerror = function () {
      console.error(`Failed to preload image: ${img.src}`);
    };
  }
});



/* Apply the class whenever the user starts typing on the textfield */

document.addEventListener('DOMContentLoaded', function() {
  const liveSearchInput = document.getElementById('live-search-input');
  const searchFlydown = document.querySelector('.live-search');

  console.log("live-search-input");

  // Function to check the animation state of the live-search div
  function checkFlydownState() {
    if (searchFlydown.getAttribute('data-animation-state') === 'open') {
      liveSearchInput.classList.add('live-search-active');
      console.log('live-search-active added');
    } else {
      liveSearchInput.classList.remove('live-search-active');
      console.log('live-search-active removed');
    }
  }

  // Observer to watch for changes in the live-search attribute
  const observer = new MutationObserver(checkFlydownState);

  // Start observing the live-searchn for attribute changes
  observer.observe(searchFlydown, { attributes: true, attributeFilter: ['data-animation-state'] });

});


/* notify button adds itself disabled attribute. the script is in the empire.js. make sure when it's added, it's remove immediately. */
document.addEventListener('DOMContentLoaded', function() {
  const target = document.querySelector('#notify-me-btn');
  
  if (target) {
    const observer = new MutationObserver((mutationList) => {
      const mutation = mutationList[0];
      if (
        mutation.attributeName === 'disabled' &&
        target.hasAttribute('disabled')
      ) {
        target.removeAttribute('disabled');
        console.log('Disabled removed from #notify-me-btn');
      }
    });
  
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }
});



/* Available Offers Accordion block in product page */
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.js-offer-toggle');
    const content = document.querySelector('.js-offer-content');
    const icon = toggle.querySelector('span:last-child');

    toggle.addEventListener('click', function () {
        content.classList.toggle('show');
        icon.textContent = content.classList.contains('show') ? '▴' : '▾';
    });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.offers-accordion').forEach(function (accordion) {
    const coupons = accordion.querySelectorAll('.coupon-block');
    const hrs = accordion.querySelectorAll('hr');

    if (coupons.length <= 1) {
      // If there's only 1 coupon, remove all <hr>
      hrs.forEach(hr => hr.remove());
    } else if (hrs.length > 0) {
      // If more than 1, remove the last <hr>
      hrs[hrs.length - 1].remove();
    }
  });
});
/* Available Offers Accordion block in product page */